module.exports = __webpack_public_path__ + "static/media/nexo-borrow.1.e8039dee.png";